import React from 'react'
import Topbar from '../components/Layout/Topbar'
import { Sidebar } from '../components/Layout/Sidebar'
import ProfileArea from '../components/Profile/ProfileArea'
import { useSelector } from 'react-redux'


const Profile = () => {
    const { error, loading, isAuthenticated,users,userProfile } = useSelector(
        (state) => state.user
      );
  return (
    <div className='flex bg-slate-100/80'>
      <Sidebar /> 
        <div className='flex h-[100vh] flex-1 flex-col overflow-y-scroll' >
        <Topbar />
            
            <ProfileArea userProfile={userProfile} />
        </div>
    </div>
  )
}

export default Profile
